// Copyright (c) 2016 Deere & Company

import KeyValuePairCollection, {getDefaultState} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import actions from '../../action-list';

const updateDownTimeCollection = (state, action) =>
    KeyValuePairCollection.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_DOWN_TIME_COLLECTION]: updateDownTimeCollection
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/shared/reducers/down-time.js